import axios from 'axios';
import axiosInstance, { clearLocalStorage, clearSessionStorage, deleteToken, getCurrentTenant, setAdminToken, setCurrentTenant, setToken } from './axiosInstance';

const baseURL = 'https://api.bigjump.app/api';
// const baseURL = "https://localhost:7017/api";
const axiosApi = axios.create({
    baseURL: baseURL,
    Accept: 'application/json',
    "Content-Type": 'application/json',
    'tenant': getCurrentTenant()
});
axiosInstance.defaults.headers.common['tenant'] = getCurrentTenant();
const AuthService = {
    getProfile: async () => {
        try {
            const response = await axiosInstance.get(`/User/profile`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to fetch user profile');
        }
    },
    updateProfile: async (data) => {
        try {
            const response = await axiosInstance.put(`/User/profile`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to update user profile');
        }
    },

    Login: async (email, password) => {
        try {
            const data = {
                email: email,
                password: password
            }
            const response = await axiosApi.post(`/User/login`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant()
                }
            });
            setToken(response.data.result.accessToken);
            localStorage.setItem('Name', response.data.result.userName);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data.errorMessages[0]);
        }
    },
    SocialLogin: async (provider, token) => {
        try {
            const data = {
                provider: provider,
                token: token
            }
            const response = await axiosApi.post(`/User/social-login`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant()
                }
            });
            setToken(response.data.result.accessToken);
            localStorage.setItem('Name', response.data.result.userName || response.data.result.firstName + ' ' + response.data.result.lastName);
            localStorage.setItem('donorEmail', response.data.result.email || response.data.result.userName);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Social login failed');
        }
    },
    Register: async (username, email, password, confirmPassword, phoneNumber) => {
        try {
            const data = {
                userName: username,
                email: email,
                password: password,
                confirmPassword: confirmPassword,
                phoneNumber: phoneNumber
            }
            const response = await axiosApi.post(`/User/register`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant()
                }
            });
            return response.data;
        } catch (error) {
            // console.log('f',error.response.data[0].description)
            throw new Error(error.response.data.errorMessages[0]);

        }
    },
    Logout: async () => {
        try {
            const response = await axiosInstance.post(`/User/logout`);
            return response.data;
        } catch (error) {
            console.error("Logout API failed:", error);
            // Optionally, we could still throw an error, but for logout, it's safer to ensure
            // the local cleanup happens regardless.
        } finally {
            deleteToken();
            clearLocalStorage();
            clearSessionStorage();
            window.location.href = '/membership';
        }
    },
    verifyEmail: async (data) => {
        try {
            const response = await axiosApi.get(`/User/ConfirmEmail`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'tenant': getCurrentTenant()
                    },
                    params: { token: data.token, userId: data.userId }
                },

            );
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to verify email');
        }
    },
    MasterUserLogin: async (email, password) => {
        try {
            const response = await axiosApi.post(`/MasterUser/login`, { email, password });
            setAdminToken(response.data.result.accessToken);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to verify email');
        }
    },
    ForgotPassword: async (email) => {
        try {
            const response = await axiosApi.post(`/User/ForgotPassword`, { email }, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant()
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to verify email');
        }
    },
    ResetPassword: async (token, email, password) => {
        try {
            const response = await axiosApi.post(`/User/ResetPassword`, { token, email, password }, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant()
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to reset password');
        }
    }
}
const BraintreeService = {
    getClientToken: async () => {
        try {
            const response = await axiosInstance.post(`/BraintreePayment/GenerateToken`);
            return response.data;

        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDetails: async (transactionId) => {
        try {
            const response = await axiosInstance.get(`/BraintreePayment/details/${transactionId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant(),
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

}
const ComponentService = {
    GetAllComponents: async () => {
        try {
            const response = await axiosInstance.get(`/AllComponents`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getComponentById: async (id) => {
        try {
            const response = await axiosInstance.get(`/Components/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getComponent: async (ComponentName) => {
        try {
            const response = await axiosInstance.get(`/Components/instances/${ComponentName}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getStaticComponent: async (ComponentName, language, isStatic) => {
        try {
            const response = await axiosInstance.get(`/Components/instances/by`, {
                params: {
                    ComponentName: ComponentName,
                    language: language,
                    isStatic: isStatic
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    CreateComponent: async (data) => {
        try {
            data.tenantId = getCurrentTenant();
            const response = await axiosInstance.post(`/Components`, data,
                { headers: { 'Content-Type': 'application/json', 'tenant': getCurrentTenant(), } }
            );
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    DeleteComponent: async (id) => {
        try {
            const response = await axiosInstance.delete(`/Components/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },

    SaveData: async (id, data) => {
        try {
            const response = await axiosApi.put(`/Components/instances/${id}/save`,
                { data }, // Send data in JSON format
                { headers: { 'Content-Type': 'application/json', 'tenant': getCurrentTenant(), } } // Explicitly set content type
            );
            return response.data;
        } catch (error) {
            console.error("Error saving instance data:", error);
            throw new Error(error.response?.data || "Request failed");
        }
    }


};
const PageService = {
    GetAllPages: async () => {
        try {
            const response = await axiosInstance.get('/Page');
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPageBySlugAndLanguage: async (slug, language) => {
        try {
            const response = await axiosInstance.get(`/Page/slug/${slug}/${language}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPageById: async (id) => {
        try {
            const response = await axiosInstance.get(`/Page/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPageByIdAndLanguage: async (id, language) => {
        try {
            const response = await axiosInstance.get(`/Page/Home/${id}/${language}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPageBySlug: async (slug) => {
        try {
            const response = await axiosInstance.get(`/Page/slug/${slug}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },

    CreatePage: async (data) => {
        try {
            const response = await axiosInstance.post('/Page', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    CreatePageForAllLanguages: async (data) => {
        try {
            const response = await axiosInstance.post('/Page/CreatePageForAllLanguages', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    UpdatePage: async (id, data) => {
        try {
            const response = await axiosInstance.put(
                `/Page/${id}`,
                {
                    title: data.title,
                    description: data.description,
                    isActive: data.isActive,
                    slug: data.slug,
                    isTitleVisible: data.isTitleVisible,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'tenant': getCurrentTenant()
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    DeletePage: async (slug) => {
        try {
            const response = await axiosInstance.delete(`/Page/slug/${slug}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetComponentsByPageId: async (id) => {
        try {
            const response = await axiosInstance.get(`/Page/${id}/components`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    CopyPageFromLanguage: async (slug, fromLanguage, toLanguage) => {
        try {
            const response = await axiosInstance.post(`/Page/CopyComponents/${slug}/${fromLanguage}/${toLanguage}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant()
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const pageComponentService = {
    GetPageComponents: async (id) => {
        try {
            const response = await axiosInstance.get(`/Page/${id}/components`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    CreatePageComponent: async (data) => {
        try {
            const response = await axiosInstance.post(`/Page/${data.pageId}/components`, data,
                { headers: { 'Content-Type': 'application/json', 'tenant': getCurrentTenant(), } }
            );
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    UpdatePageComponent: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/Page/components/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    DeletePageComponent: async (id, data) => {
        try {
            const response = await axiosInstance.delete(`/Page/components/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    UpdatePageComponentOrder: async (data) => {
        try {
            const response = await axiosInstance.post(`/Page/components/order`, data,
                { headers: { 'Content-Type': 'application/json', 'tenant': getCurrentTenant(), } }
            );
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const MediaService = {
    getMedia: async () => {
        try {
            const response = await axiosInstance.get(`/TenantImages`, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant(),
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getMediaById: async (id) => {
        try {
            const response = await axiosInstance.get(`/TenantImages/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    createMedia: async (data) => {
        try {
            const response = await axiosInstance.post(`/TenantImages`, data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'tenant': getCurrentTenant(),
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateMedia: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/TenantImages/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    deleteMedia: async (id) => {
        try {
            const response = await axiosInstance.delete(`/TenantImages/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const CampaignService = {
    getCampaigns: async () => {
        try {
            const response = await axiosInstance.get(`/Campaigns`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getRecurringCampaigns: async (sectionId) => {
        try {
            const url = sectionId ? `/Campaigns/recurring?sectionId=${sectionId}` : `/Campaigns/recurring`;
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data || error.message);
        }
    },
    getCampaignByIdAndLanguage: async (id, language, includeInactive = false) => {
        try {
            const response = await axiosInstance.get(`/Campaigns/ByLang/${id}/${language}?includeInactive=${includeInactive}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getActiveCampaigns: async (activeStatus = true) => {
        try {
            const response = await axiosInstance.get(`/Campaigns/GetActiveCampaigns/${activeStatus}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getCampaignById: async (id, includeInactive = false) => {
        try {
            const response = await axiosInstance.get(`/Campaigns/${id}?includeInactive=${includeInactive}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    createCampaign: async (data) => {
        try {
            const response = await axiosInstance.post(`/Campaigns`, data, {
                headers: {
                    'tenant': getCurrentTenant(),
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateCampaign: async (id, data) => {
        try {
            console.log(data);
            const response = await axiosInstance.put(`/Campaigns/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    deleteCampaign: async (id) => {
        try {
            const response = await axiosInstance.delete(`/Campaigns/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateCampaignOrder: async (orderData) => {
        try {
            const response = await axiosInstance.post(`/Campaigns/order`, orderData, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant(),
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const CampaignTypeService = {
    getCampaignTypes: async () => {
        try {
            const response = await axiosInstance.get(`/CampaignSection`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getGeneralCampaignTypes: async () => {
        try {
            const response = await axiosInstance.get(`/CampaignSection?isGeneralDonation=true`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getRecurringCampaignTypes: async () => {
        try {
            const response = await axiosInstance.get(`/CampaignSection?hasRecurringCampaigns=true`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data || error.message);
        }
    },
    getCampaignTypeByIdAndLanguage: async (id, language) => {
        try {
            const response = await axiosInstance.get(`/CampaignSection/byIdAndLanguage/${id}/${language}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getCampaignTypeById: async (id) => {
        try {
            const response = await axiosInstance.get(`/CampaignSection/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    createCampaignType: async (data) => {
        try {
            const response = await axiosInstance.post(`/CampaignSection`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateCampaignType: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/CampaignSection/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    deleteCampaignType: async (id) => {
        try {
            const response = await axiosInstance.delete(`/CampaignSection/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const DonationService = {
    createDonation: async (data) => {
        try {
            const response = await axiosInstance.post(`/Donation`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant(),
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonations: async () => {
        try {
            const response = await axiosInstance.get(`/Donation`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonationById: async (id) => {
        try {
            const response = await axiosInstance.get(`/Donation/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonationByCampaignId: async (campaignId) => {
        try {
            const response = await axiosInstance.get(`/Donation/campaign/${campaignId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonationByDonorEmail: async (donorEmail) => {
        try {
            const response = await axiosInstance.get(`/Donation/donor/${donorEmail}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonorStatistics: async (donorEmail) => {
        try {
            const response = await axiosInstance.get(`/Donation/donor-statistics/${donorEmail}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonors: async () => {
        try {
            const response = await axiosInstance.get(`/Donation/donors`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateDonationNotes: async (id, notes) => {
        try {
            const response = await axiosInstance.put(`/Donation/${id}/notes`, { notes }, {
                headers: {
                    'Content-Type': 'application/json',
                    'tenant': getCurrentTenant(),
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to update notes');
        }
    },
    getDonationSummary: async () => {
        try {
            const response = await axiosInstance.get(`/Donation/summary`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to get summary');
        }
    },
    getDonationAnalytics: async (days = 30) => {
        try {
            const response = await axiosInstance.get(`/Donation/analytics?days=${days}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to get analytics');
        }
    }
}
const SubscriptionService = {
    createSubscription: async (data) => {
        try {
            const response = await axiosInstance.post(`/CustomSubscription`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getDonorSubscriptions: async (donorEmail) => {
        try {
            const response = await axiosInstance.get(`/CustomSubscription/Email/${donorEmail}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    SuspendSubscription: async (id) => {
        try {
            const response = await axiosInstance.post(`/CustomSubscription/${id}/suspend`, { id: id });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    ReactivateSubscription: async (id) => {
        try {
            const response = await axiosInstance.post(`/CustomSubscription/${id}/reactivate`, { id: id });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    CancelSubscription: async (id) => {
        try {
            const response = await axiosInstance.post(`/CustomSubscription/${id}/cancel`, { id: id });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetInvoiceById: async (id) => {
        try {
            const response = await axiosInstance.get(`/CustomSubscription/invoices/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
}
const PaymentService = {
    GetPaymentDetailsPayPal: async (token, PayerID) => {
        try {
            const response = await axiosInstance.get(`/PayPal/success?token=${token}&PayerID=${PayerID}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPaymentDetailsAhlyMomken: async (id) => {
        try {
            const response = await axiosInstance.get(`/AhlyMomken/success`, {
                params: {
                    merchantInvoiceRef: id
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPaymentDetailsFawry: async (data) => {
        try {
            const response = await axiosInstance.get(`/Fawry/success`, {
                params: data
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    GetPaymentDetailsNoon: async (id) => {
        try {
            const response = await axiosInstance.get(`/Noon/success`, {
                params: {
                    merchantInvoiceRef: id
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const MailTemplateService = {
    getMailTemplates: async () => {
        try {
            const response = await axiosInstance.get(`/MailTemplate`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getMailTemplateById: async (id) => {
        try {
            const response = await axiosInstance.get(`/MailTemplate/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getMailTemplateByName: async (name) => {
        try {
            const response = await axiosInstance.get(`/MailTemplate/name/${name}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    createMailTemplate: async (data) => {
        try {
            const response = await axiosInstance.post(`/MailTemplate`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateMailTemplate: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/MailTemplate/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    deleteMailTemplate: async (id) => {
        try {
            const response = await axiosInstance.delete(`/MailTemplate/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}
const SettingsService = {
    getPublicConfig: async () => {
        try {
            const response = await axiosInstance.get(`/TenantSettings/public-config`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to get public config');
        }
    },
    getSettings: async (id) => {
        try {
            const response = await axiosInstance.get(`/TenantSettings/configurations/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    getMinSettings: async (id) => {
        try {
            const response = await axiosInstance.get(`/TenantSettings/minconfigurations/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    updateSettings: async (id, data) => {
        try {
            data.tenantId = getCurrentTenant();
            data.id = id;
            const response = await axiosInstance.put(`/TenantSettings/Configurations/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    },
    testEmail: async () => {
        try {
            const response = await axiosInstance.get(`/TenantSettings/Configurations/testEmail`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to test email');
        }
    }
}
const PaymentMethodService = {
    getPaymentMethods: async () => {
        try {
            const response = await axiosInstance.get('/PaymentMethod');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to fetch payment methods');
        }
    },
    updatePaymentMethod: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/PaymentMethod/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to update payment method');
        }
    },
    getPublicPaymentMethods: async () => {
        try {
            const response = await axiosInstance.get('/PaymentMethod/public/enabled');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to fetch payment methods');
        }
    },


};
const LanguageService = {
    getLanguages: async () => {
        try {
            const response = await axiosInstance.get('/Language');
            return response.data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
};

const SearchService = {
    search: async (q, { types, limit } = {}) => {
        try {
            const params = { q };
            if (types?.length) {
                params.types = types.join(',');
            }
            if (limit) {
                params.limit = limit;
            }
            const response = await axiosInstance.get('/search', { params });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Search failed');
        }
    },
    getTypes: async () => {
        try {
            const response = await axiosInstance.get('/search/types');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.errorMessages?.[0] || 'Failed to load search types');
        }
    },
};

export {
    AuthService,
    ComponentService,
    MediaService,
    CampaignService,
    CampaignTypeService,
    PageService,
    pageComponentService,
    DonationService,
    PaymentService,
    SubscriptionService,
    BraintreeService,
    MailTemplateService,
    SettingsService,
    PaymentMethodService,
    LanguageService,
    SearchService
}
